import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        ...theme.typographyPresets.bodyTertiaryBold,
        cursor: 'pointer',
        top: 'calc(50% - 16.5px)',
        left: 'calc(50% - 80px)',
        color: theme.colors.black,
        borderRadius: 2,
        padding: 7,
        zIndex: 1,
        position: 'absolute',
        backgroundColor: theme.colors.white,
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.2)',
        '&:hover': {
            backgroundColor: theme.colors.light.lightGray,
        },
    },
    icon: {
        margin: '0 10px 0 5px',
        fontSize: 14,
    },
}))
